import * as React from "react"
const Genre2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.698 10.855a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM7.698 20.855a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM14.698 14.855h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5Zm-10-10h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5Z"
    />
  </svg>
)
export default Genre2